// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/main.scss
// module id = 17
// module chunks = 0